import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IconButton, Badge, Button, Menu, MenuItem } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import MenuIcon from "@mui/icons-material/Menu";
import rocket from "../images/Cartoon_space_rocket.png"
// import '@fontsource/orbitron'; 
import '@fontsource/rajdhani';


function Header({ user, cartItems }) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const totalQuantity = (cartItems || []).reduce((sum, item) => sum + item.quantity, 0);

  const handleCartClick = () => {
    navigate("/cart"); // Redirect to the cart page
  };

  const handleFireworksClick = () => {
    navigate("/homepage"); // Redirect to the listings page
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNavigate = (path) => {
    navigate(path);
    handleMenuClose();
  };

  return (
    <div style={styles.container}>
      {/* Fireworks Button */}
      <Button
  variant="text"
  sx={{
    backgroundColor: "transparent",
    border: "none",
    color: "inherit",
    boxShadow: "none",
    "&:hover": { backgroundColor: "transparent" },
    fontFamily: "'Rajdhani', sans-serif",
    fontSize: { xs: "25px", sm: "30px", md: "35px" }, // Adjust text size per screen
    fontWeight: 1000,
    letterSpacing: "0.05em",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  }}
  onClick={handleFireworksClick}
>
  <img 
    src={rocket} 
    style={{
      width: "10vw", // Scales based on viewport width
      maxWidth: "50px", // Prevents image from getting too big
      height: "auto",
    }} 
  />
  SONIC BLAST FIREWORKS
</Button>


  {/* This will push the next items to the right */}
  <div style={{ marginLeft: "auto", display: "flex", gap: "15px" }}>
    {/* Cart Icon with Badge */}
    <IconButton onClick={handleCartClick} style={styles.iconButton}>
        <Badge badgeContent={totalQuantity} color="secondary">
          <ShoppingCartIcon style={styles.icon} />
        </Badge>
      </IconButton>

      {/* Burger Menu Icon */}
      <IconButton onClick={handleMenuClick} style={styles.menuButton}>
        <MenuIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        <MenuItem onClick={() => handleNavigate("/profile")}>Profile</MenuItem>
        <MenuItem onClick={() => handleNavigate("/orders")}>Orders</MenuItem>
        {user.admin && <>
        <MenuItem onClick={() => handleNavigate("/manageusers")}>Manage Users</MenuItem>
        <MenuItem onClick={() => handleNavigate("/manageInviteCodes")}>Manage Invite Codes</MenuItem>
        <MenuItem onClick={() => handleNavigate("/managediscounts")}>Manage Discount Rules</MenuItem>
        </>
        }
      </Menu>
  </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    backgroundColor: "#333",
    color: "#fff",
  },
  iconButton: {
    marginLeft: "auto",
    color: "#fff",
  },
  icon: {
    fontSize: "1.5rem",
  },
  fireworksButton: {
    backgroundColor: "#333",
    color: "#fff",
  },
  menuButton: {
    color: "#fff",
  },
};

export default Header;
